// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 2H4V4H5V8H2V22H8.5V15H15.5V22H22V8H19V4H20V2ZM13 7H15V9H13V11H11V9H9V7H11V5H13V7Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.5 22V17H13.5V22H10.5Z"}}]};

const HospitalFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hospital-filled',
    ref,
    icon: element,
  },
));

HospitalFilledIcon.displayName = 'HospitalFilledIcon';

export default HospitalFilledIcon;
